// extracted by mini-css-extract-plugin
export default {"root":"FeaturesButton__root--1EC8X","informer":"FeaturesButton__informer--2VEY4","root_mobile":"FeaturesButton__root_mobile--z8m4n","dot":"FeaturesButton__dot--3NWhR"};